// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Map from "@rescript/runtime/lib/es6/Belt_Map.js";
import * as LumiOption from "lumi-rescript/lib/es6/src/LumiOption.res.js";
import * as ObjectStyle$LumiFacilityMap from "./ObjectStyle.res.js";

function Make(Cmp) {
  let empty = Belt_Map.make(Cmp);
  let fromArray = __x => Belt_Map.fromArray(__x, Cmp);
  let singleton = (k, v) => Belt_Map.fromArray([[
      k,
      v
    ]], Cmp);
  let update = Belt_Map.update;
  let merge = (a, b) => Belt_Map.merge(a, b, (_key, x, y) => LumiOption.unionWith(ObjectStyle$LumiFacilityMap.merge, x, y));
  let mergeLast = (a, b) => Belt_Map.merge(a, b, (_key, x, y) => LumiOption.unionWith((param, l) => l, x, y));
  return {
    empty: empty,
    fromArray: fromArray,
    singleton: singleton,
    update: update,
    merge: merge,
    mergeLast: mergeLast,
    Cmp: Cmp
  };
}

export {
  Make,
}
/* ObjectStyle-LumiFacilityMap Not a pure module */
